import { briefs } from "@/mocks/chigua";

const dotColors = ["bg-primary-500", "bg-accent-500", "bg-secondary-500", "bg-primary-500", "bg-accent-500", "bg-secondary-500"];

export default function Brief() {
  return (
    <section id="brief" className="border-y border-background-200 bg-background-100/60">
      <div className="container-page grid grid-cols-1 gap-8 py-12 md:py-16 lg:grid-cols-12 lg:gap-12">
        {/* left heading + summary card */}
        <div className="lg:col-span-4">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-accent-700">
            <i className="ri-broadcast-line"></i>
            DAILY BRIEF
          </p>
          <h2 className="section-title mt-3">必看快讯速览</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            以分钟为单位快速消化重要动态，吃瓜日报必看内容随到随更，别让热点从你指缝溜走。
          </p>
          <div className="mt-6 rounded-2xl border border-accent-200 bg-accent-50 p-5">
            <p className="flex items-center gap-2 text-sm font-semibold text-accent-900">
              <i className="ri-notification-3-line"></i>
              错过了上午的瓜？
            </p>
            <p className="mt-2 text-sm leading-relaxed text-accent-800">
              订阅后可于每日 09:00 收到前一日热度复盘与当日必看清单，不错过任何一波。
            </p>
            <a href="#newsletter" className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-accent-600">
              开启推送提醒 <i className="ri-send-plane-line"></i>
            </a>
          </div>
        </div>

        {/* timeline */}
        <div className="lg:col-span-8">
          <div className="relative">
            <span className="absolute bottom-2 left-[15px] top-2 w-px bg-foreground-200 md:left-[17px]"></span>
            <ul className="space-y-3">
              {briefs.map((b, i) => (
                <li key={i} className="relative flex items-start gap-4">
                  <span className={`relative z-10 mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${dotColors[i % dotColors.length]} text-background-50 md:h-9 md:w-9`}>
                    <i className="ri-focus-3-line text-sm"></i>
                  </span>
                  <div className="flex flex-1 flex-col rounded-xl border border-background-200 bg-background-50 p-3.5 transition hover:bg-background-100 sm:flex-row sm:items-center sm:gap-4 md:p-4">
                    <div className="flex items-center gap-2 sm:w-24 sm:shrink-0">
                      <span className="font-mono text-xs font-bold text-foreground-800">{b.time}</span>
                      <span className="label-cat bg-secondary-100 text-secondary-900">{b.tag}</span>
                    </div>
                    <a
                      href="#featured"
                      className="mt-2 text-sm font-medium leading-snug text-foreground-800 transition hover:text-primary-600 sm:mt-0"
                    >
                      {b.text}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}